import React, { Component } from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import PropTypes from 'prop-types';
import Toggler from '@fiverr/ui_toggle';
import tracker from '../../../../service/tracker';
import { EVENTS_MAPPING } from '../../../../utils/constants';
import { objectValues, customToString } from '../../../../utils';
import './index.scss';

const DEFAULT_PROPS = {
    headAsLink: true
};

class SubCategoriesFilter extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selected: this.getSelected()
        };

        this.handleLinkClick = this.handleLinkClick.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.data !== prevProps.data) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                selected: this.getSelected()
            });
        }
    }

    getSelected() {
        const { alias, children, headAsLink } = this.props.data;
        const selectedChild = objectValues(children).filter((child) => child.selected)[0];

        return selectedChild && headAsLink ? selectedChild.alias : alias;
    }

    handleLinkClick(e, { params }, alias) {
        e.preventDefault && e.preventDefault();

        if (this.state.selected === alias) {
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);

        urlParams.set('search_in', params.search_in);
        urlParams.set('sub_category', params.sub_category);

        const customParams = [...urlParams.entries()];
        const payload = {
            location: 'Top Filter',
            alias,
            scId: params.sub_category
        };

        tracker.trackSCFilter(EVENTS_MAPPING.FILTERS_APPLY, payload);

        window.location.href = `${window.location.href.split('?')[0]}?${customToString(customParams)}`;
    }

    onOpen() {
        tracker.click(EVENTS_MAPPING.CLICK.TARGETS.SUB_CATEGORY_FILTER);
        tracker.trackFilterGroupOpen(EVENTS_MAPPING.CLICK.TARGETS.SUB_CATEGORY_FILTER);
    }

    render() {
        const data = {
            ...DEFAULT_PROPS,
            ...this.props.data
        };

        const { alias, url, children, count, headAsLink } = data;

        if (!children) {
            return null;
        }

        return (
            <Toggler ref={(toggler) => this.toggler = toggler}
                togglerWillOpen={this.syncValues} togglerDidOpen={this.onOpen}>
                {({ isOpen, toggle, preventCloseAction }) => (
                    <div className={'top-filters-subcategories-filter as-filter'} ref={preventCloseAction}>
                        <button className={classNames({ 'is-open': isOpen }, { 'filtered-sc': headAsLink })} onClick={toggle}>
                            <I18n k="search_perseus.filter_builder.sub_category.category"/>
                        </button>
                        <ul className={classNames('subcategories-list', { 'is-open': isOpen })}>
                            <li className="item">
                                {
                                    headAsLink ?
                                        <a href={url}
                                            onClick={(e) => this.handleLinkClick(e, data, alias)}>
                                            {alias}
                                        </a> : <a href="#!" className="selected">{alias}</a>
                                }
                                <span> ({count && count.toLocaleString()}) </span>
                            </li>

                            {children.map((child) => (
                                <React.Fragment key={child.alias}>
                                    <li className="item">
                                        <a href={headAsLink && child.selected ? '#!' : child.url}
                                            className={classNames({ 'selected': headAsLink && child.selected })}
                                            onClick={(e) => this.handleLinkClick(e, child, child.alias)}>
                                            {child.alias}
                                        </a>
                                        <span> ({child.count && child.count.toLocaleString()}) </span>
                                    </li>
                                </React.Fragment>
                            ))}
                        </ul>
                    </div>
                )}
            </Toggler>
        );
    }
}

SubCategoriesFilter.propTypes = {
    data: PropTypes.shape({
        alias: PropTypes.string.isRequired,
        count: PropTypes.number,
        children: PropTypes.array,
        globalFiltersQuery: PropTypes.string,
        headAsLink: PropTypes.bool
    })
};

export default SubCategoriesFilter;
